var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.397 19.3867C32.7057 19.078 33.1651 18.9757 33.5755 19.1244C37.6126 20.5863 40.5001 24.4543 40.5001 28.9996C40.5001 34.7986 35.7991 39.4996 30.0001 39.4996C25.4548 39.4996 21.5868 36.6121 20.1249 32.5751C19.9762 32.1646 20.0785 31.7052 20.3872 31.3965C20.6958 31.0878 21.1552 30.9856 21.5657 31.1342C22.4411 31.4512 23.3866 31.6246 24.3751 31.6246C28.9314 31.6246 32.6251 27.9309 32.6251 23.3746C32.6251 22.3861 32.4517 21.4406 32.1347 20.5652C31.9861 20.1548 32.0883 19.6954 32.397 19.3867ZM34.821 22.3037C34.8568 22.656 34.8751 23.0132 34.8751 23.3746C34.8751 29.1736 30.1741 33.8746 24.3751 33.8746C24.0137 33.8746 23.6565 33.8563 23.3042 33.8206C24.8029 35.8983 27.2445 37.2496 30.0001 37.2496C34.5564 37.2496 38.2501 33.5559 38.2501 28.9996C38.2501 26.244 36.8988 23.8024 34.821 22.3037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightToggle);
export default __webpack_public_path__ + "static/media/night_toggle.17270bbfe90dbff0fdf3e9ea5765c219.svg";
export { ForwardRef as ReactComponent };